__turbopack_context__.v({
  "app_light_theme": "total-product-set-item-module-scss-module__GUuR0a__app_light_theme",
  "totalProductSetItem": "total-product-set-item-module-scss-module__GUuR0a__totalProductSetItem",
  "totalProductSetItem__dl": "total-product-set-item-module-scss-module__GUuR0a__totalProductSetItem__dl",
  "totalProductSetItem__title": "total-product-set-item-module-scss-module__GUuR0a__totalProductSetItem__title",
  "totalProductSetItem__titleInner": "total-product-set-item-module-scss-module__GUuR0a__totalProductSetItem__titleInner",
});
